import React from "react";
import styled from "@emotion/styled";
import { generateMessage } from "./LoadingMessageHelper";

const Message = styled("div")`
    color: #6f7479;
    font-size: 26px;
    margin: 50px auto 0;
    text-align: center;
`;

interface LoadingMessageProps {
    className?: string;
}

class LoadingMessage extends React.Component<LoadingMessageProps> {
    public render() {
        return (
            <div className="Message__container">
                <Message>{generateMessage()}</Message>
            </div>
        );
    }
}

export default LoadingMessage;
